import {createUseStyles} from 'react-jss';

export default createUseStyles({
    mainDiv: {
        width: '100%',
        padding: '10px',
        boxSizing: 'border-box',
        borderRadius: '10px',
    },
});
